<template>
  <!--  <div v-if="user_accesses && userService && userService.hasAccess(user_accesses, ['admin'])"-->
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin']))" class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast/>
        <Toolbar class="p-mb-4 table-toolbar">
          <template slot="left">
            <Button label="New" icon="pi pi-plus" class="p-button-success p-mr-2" @click="openNew" />
            <Button label="Delete" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected"
                    :disabled="!selectedUsers || !selectedUsers.length"/>
          </template>

          <template slot="right">
            <!-- <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" label="Import" chooseLabel="Import"
                        class="p-mr-2 p-d-inline-block" :disabled="true"/> -->
            <Button label="Export" icon="pi pi-upload" class="p-button-info" @click="exportCSV($event)"/>
          </template>
        </Toolbar>

        <DataTable ref="dt" :value="users" :selection.sync="selectedUsers" dataKey="id" :paginator="true"
                   :rows="10" :filters="filters"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[5,10,25]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users">
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">Manage Users</h5>
              <span class="p-input-icon-left">
                  <i class="pi pi-search"/>
                  <InputText v-model="filters['global']" placeholder="Search..."/>
              </span>
            </div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 4rem"></Column>
          <Column header="Image">
            <template #body="slotProps">
              <img @click="showGallery(slotProps.data)"
                   :src="slotProps.data.images && slotProps.data.images.length > 0 ? slotProps.data.images[0].path : 'assets/layout/images/profiles/default.png'"
                   :alt="slotProps.data.username" class="product-image"/>
            </template>
          </Column>
          <Column field="username" header="Username" sortable></Column>
          <Column field="first_name" header="First Name" sortable></Column>
          <Column field="last_name" header="Last Name" sortable></Column>
          <Column field="roles" header="Roles" sortable>
            <template #body="slotProps">
              <span>{{displayRoles(slotProps.data.roles)}}</span>
            </template>
          </Column>
          <!-- <Column field="status" header="Status" sortable>
            <template #body="slotProps">
              <span :class="'product-badge status-' + slotProps.data.status.toLowerCase()">{{slotProps.data.status}}</span>
            </template>
          </Column> -->
          <Column>
            <template #body="slotProps">
              <Button icon="pi pi-lock" class="p-button-rounded p-button-success p-mr-2"
                      @click="showRoleModal(slotProps.data)"/>
              <!--              <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"-->
              <!--                      @click="editUser(slotProps.data)" :disabled=true />-->
              <Button icon="pi pi-key" class="p-button-rounded p-button-warning p-mr-2"
                      @click="resetPassword(slotProps.data)"/>
              <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                      @click="confirmDeleteUser(slotProps.data)"/>
            </template>
          </Column>
        </DataTable>

        <div v-if="users == null" class="loader">
          <scale-out class="loader-style"></scale-out>
        </div>

        <Dialog :visible.sync="deleteUserDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="user">Are you sure you want to delete <b>{{user.username}}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUserDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteUser"/>
          </template>
        </Dialog>

        <Dialog :visible.sync="deleteUsersDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="user">Are you sure you want to delete the selected users?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUsersDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedUsers"/>
          </template>
        </Dialog>

        <Dialog class="role-dialog" header="Add Roles" :visible.sync="addRoleModal" :style="{width: '30vw'}"
                :modal="true">
          <span class="p-field">
            <MultiSelect class="role-multiselect" id="roles" v-model="user_roles" :options="role_list"
                         optionLabel="name" placeholder="Select Roles"/>
            <!--<InputText class="card-input" id="roles" type="text" v-model="staff.roles"/>-->
          </span>
          <template #footer>
            <Button label="Cancel" icon="pi pi-times" @click="addRoleModal = false" class="p-button-text"/>
            <Button label="Submit" icon="pi pi-check" @click="addRole" autofocus/>
          </template>
        </Dialog>

        <Dialog class="role-dialog" header="Reset Password" :visible.sync="resetPasswordDialog" :style="{width: '30vw'}"
                :modal="true">

          <div class="p-col-12">
            <span class="p-field">
              <label style="display: block;" for="reset_pass">Password</label>
              <InputText class="p-col-12 p-lg-6 card-input" id="reset_pass" type="password" v-model="reset_pass"/>
            </span>
          </div>

          <div class="p-col-12">
            <span class="p-field">
              <label style="display: block;" for="reset_confirm_pass">Confirm password</label>
              <InputText class="p-col-12 p-lg-6 card-input" id="reset_confirm_pass" type="password"
                         v-model="reset_confirm_pass"/>
            </span>
          </div>

          <template #footer>
            <Button label="Cancel" icon="pi pi-times" @click="resetPasswordDialog = false" class="p-button-text"/>
            <Button label="Submit" icon="pi pi-check" @click="resetPasswordConfirm" autofocus/>
          </template>

        </Dialog>

        <Dialog class="role-dialog" header="New User" :visible.sync="newUserDialog" :style="{width: '50vw'}"
                :modal="true">

          <div class="p-grid nested-grid">
            <div class="p-col-12 p-lg-5">
              <h3 class="card-title">
                Profile Info
              </h3>

              <div class="p-grid">
                <div class="p-col-12">
                  <span class="p-field">
                    <label for="username">Username</label>
                    <InputText class="card-input" id="username" type="text" v-model="new_user.username"/>
                  </span>
                </div>
                <div class="p-col-12">
                  <span class="p-field">
                    <label for="first_name">First Name</label>
                    <InputText class="card-input" id="first_name" type="text" v-model="new_user.first_name"/>
                  </span>
                </div>
                <div class="p-col-12">
                  <span class="p-field">
                    <label for="last_name">Last Name</label>
                    <InputText class="card-input" id="last_name" type="text" v-model="new_user.last_name"/>
                  </span>
                </div>
                <!-- <div class="p-col-12">
                  <span class="p-field">
                    <label for="password">Password</label>
                    <InputText class="card-input" id="password" type="password" v-model="new_user.password"/>
                  </span>
                </div>
                <div class="p-col-12">
                  <span class="p-field">
                    <label for="confirm_password">Confirm Password</label>
                    <InputText class="card-input" id="confirm_password" type="password"
                               v-model="new_user.confirm_password"/>
                  </span>
                </div> -->
                <div class="p-col-12">
                  <span class="p-field">
                    <label for="roles">Roles</label>
                    <MultiSelect class="card-input" id="user_roles" v-model="new_user.roles" :options="role_list"
                                 optionLabel="name" placeholder="Select Roles"/>
                  </span>
                </div>

              </div>

            </div>

            <div class="p-col-12 p-lg-1"></div>

            <div class="p-col-12 p-lg-5">
              <h3 class="card-title">
                Contact Info
              </h3>

              <div class="p-col-12">
                <span class="p-field">
                  <label for="email">Email</label>
                  <InputText class="card-input" id="email" type="text" v-model="new_user.email"/>
                </span>
              </div>
              <div class="p-col-12">
                <span class="p-field">
                  <label for="mobile">Mobile</label>
                  <InputText class="card-input" id="mobile" type="text" v-model="new_user.mobile"/>
                </span>
              </div>
              <div class="p-col-12">
                <span class="p-field">
                  <label for="landline">Landline</label>
                  <InputText class="card-input" id="landline" type="text" v-model="new_user.landline"/>
                </span>
              </div>

            </div>
          </div>

          <template #footer>
            <Button label="Cancel" icon="pi pi-times" @click="newUserDialog = false" class="p-button-text"/>
            <Button label="Submit" icon="pi pi-check" @click="saveUser" autofocus/>
          </template>

        </Dialog>

        <Galleria :value="images" :responsiveOptions="responsiveOptions" :numVisible="7"
                  containerStyle="max-width: 850px"
                  :circular="true" :fullScreen="true" :showItemNavigators="true" :showThumbnails="false"
                  :visible.sync="displayGallery">
          <!--                  v-model:visible="displayGallery">-->
          <template #item="slotProps">
            <img :src="slotProps.item.itemImageSrc" :alt="slotProps.item.alt" style="width: 100%; display: block;"/>
          </template>
          <template #thumbnail="slotProps">
            <img :src="slotProps.item.thumbnailImageSrc" :alt="slotProps.item.alt" style="display: block;"/>
          </template>
        </Galleria>

      </div>
    </div>
  </div>

</template>

<script>
  import UserService from '../../services/UserService';
  import RoleService from '../../services/RoleService';
  import {ScaleOut} from 'vue-loading-spinner';

  export default {
    components: { ScaleOut },
    data() {
      return {
        users: null,
        newUserDialog: false,
        addRoleModal: false,
        resetPasswordDialog: false,
        deleteUserDialog: false,
        deleteUsersDialog: false,
        user: {},
        role_list: [],
        user_roles: [],
        reset_confirm_pass: "",
        reset_pass: "",
        new_user: {
          username: "",
          first_name: "",
          last_name: "",
          // password: "",
          // confirm_password: "",
          email: "",
          mobile: "",
          landline: "",
          roles: []
        },
        selectedUsers: null,
        filters: {},
        submitted: false,
        displayGallery: false,
        images: [],
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 5
          },
          {
            breakpoint: '768px',
            numVisible: 3
          },
          {
            breakpoint: '560px',
            numVisible: 1
          }
        ],
        user_accesses: this.$store.state.accesses,
        userService: null,
        roleService: null,
      }
    },
    created() {
      this.userService = new UserService();
      this.roleService = new RoleService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      this.userService.listUsers().then(response => this.users = response.data.users);
      this.roleService.listRoles().then(response => this.role_list = this.mapRoles(response.data.roles));
    },
    methods: {
      mapRoles(roles) {
        roles = roles ? roles : this.user.roles;
        if (!roles || roles.length === 0)
          return [];

        return roles.map(role => {
          const item = {};
          item.name = role.name;
          // item.name = role.name.replace("_", " ").replace(/\b[a-z]/g, match => match.toUpperCase());
          item.code = role.name;
          return item;
        });
      },
      displayRoles(roles) {
        roles = this.mapRoles(roles);
        if (!roles || roles.length === 0)
          return "";

        return roles.map(role => role.name).join(", ");
      },
      formatCurrency(value) {
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      },
      openNew() {
        this.newUserDialog = true;
        this.new_user = {
          username: "",
          first_name: "",
          last_name: "",
          // password: "",
          // confirm_password: "",
          email: "",
          mobile: "",
          landline: "",
          roles: []
        };
      },
      showGallery(user) {
        this.user = this.users[this.findIndexById(user.id)];
        this.images = [
          {
            "itemImageSrc": user.images[0].path,
            "thumbnailImageSrc": user.images[0].path,
            "alt": user.username,
            "title": user.username
          }
        ];
        this.displayGallery = !this.displayGallery;
      },
      saveUser() {
        this.userService.setUser(this.new_user).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'User Added!',
              life: 3000
            });
            // this.users.push(this.new_user);
            // this.newUserDialog = false;
            // this.new_user = {};
            location.reload()
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to add user!',
              detail: result.data.error
            });
          }
        });
      },
      showRoleModal(user) {
        this.user = user;
        this.user_roles = this.mapRoles(user.roles);
        this.addRoleModal = true;
      },
      addRole() {
        this.userService.setUserRole(this.user.id, this.user_roles).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Roles Updated',
              life: 3000
            });
            location.reload();
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to update roles!',
              detail: result.data.error
            });
          }
        });
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].id === id) {
            index = i;
            break;
          }
        }

        return index;
      },
      resetPassword(user) {
        this.user = user;
        this.resetPasswordDialog = true;
      },
      resetPasswordConfirm() {
        this.userService.resetPassword(this.user.id, this.reset_pass, this.reset_confirm_pass).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Password Changed!',
              life: 3000
            });
            this.reset_pass = "";
            this.reset_confirm_pass = "";
            this.user = {};
            this.resetPasswordDialog = false;
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to change password!',
              detail: result.data.error
            });
          }
        });
      },
      confirmDeleteUser(user) {
        this.user = user;
        this.deleteUserDialog = true;
      },
      deleteUser() {
        this.users = this.users.filter(val => val.id !== this.user.id);
        this.userService.deleteUsers([this.user.id]).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'User Deleted!',
              life: 3000
            });
            this.deleteUserDialog = false;
            this.user = {};
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
      },
      createId() {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteUsersDialog = true;
      },
      deleteSelectedUsers() {
        this.users = this.users.filter(val => !this.selectedUsers.includes(val));
        this.userService.deleteUsers(this.selectedUsers.map((obj) => obj.id)).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Selected Users Deleted!',
              life: 3000
            });
            this.selectedUsers = null;
            this.deleteUsersDialog = false;
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-image {
    width: 100px;
    border-radius: 2em;

    &:hover {
      cursor: pointer;
    }

    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
  }

  .p-dialog .product-image {
    width: 150px;
    margin: 0 auto 2rem auto;
    display: block;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;

    &.status-active {
      background: #C8E6C9;
      color: #256029;
    }

    &.status-inactive {
      background: #FFCDD2;
      color: #C63737;
    }
  }

  .role-multiselect {
    width: 100%;
    margin-bottom: 1rem;
  }

  .card-subtitle {
    margin: 0;
    margin-bottom: 3em;
  }

  .card-title {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .card-input {
    width: 100%;
    margin-bottom: 1rem;
  }

  .capital {
    text-transform: capitalize;
  }
</style>
